
import { Component, Inject, OnInit, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SettingsStore } from '@core/settings';
import { AnalyticEvent, EventFooterArticleType } from '@core/analytics';
import { scrollToTop } from 'app/shared/utils';
import { SkinningService } from '@core/skin';
import { UxService } from '@core/ux';
import { environment } from 'environments/environment';

declare var Didomi;


import { RouterModule } from '@angular/router';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { AnalyticsDirective } from '@shared/directives/google-analytics.directive';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
    RouterModule,
    TranslocoPipe,
    AnalyticsDirective
]
})
export class FooterComponent  implements OnInit {
    private readonly settings = inject(SettingsStore);
    private readonly transloco = inject(TranslocoService);
    // Re-runs when the active language changes (Transloco's langChanges$ is a
    // BehaviorSubject — fires immediately with current lang). The computed
    // booleans below depend on it, so they recompute exactly once per lang.
    private readonly activeLang = toSignal(this.transloco.langChanges$, { initialValue: '' });

    public operator: any;
    public socialLinks: any[] = [];
    public storeLinks: any[] = [];
    public operatorLinks: any[] = [];
    public appVersion: string = '';
    public AnalyticEvent = AnalyticEvent;
    public EventFooterArticleType = EventFooterArticleType;
    public currentYear: string = new Date().getFullYear().toString();
    protected readonly scrollToTop = scrollToTop;

    constructor(
        @Inject(SkinningService) public skinning,
        public ux: UxService
    ) {
    }

    public ngOnInit(): void {
        this.appVersion = environment.applicationVersion;
        this.operator = environment.operator;
        this.socialLinks = this.operator.externalLinks?.filter(link => link.type == 'social');
        this.storeLinks = this.operator.externalLinks?.filter(link => link.type == 'store');
    }

    // `getTranslation(lang)[key]` reads the dict directly so we do NOT trigger
    // Transloco's missing-key handler on every change-detection tick — that's
    // what `translate(key)` would do (and what was flooding the console).
    private hasKey(key: string): boolean {
        const lang = this.activeLang();
        if (!lang) return false;
        const dict = this.transloco.getTranslation(lang) as Record<string, string> | undefined;
        const value = dict?.[key];
        return !!value && value !== key;
    }

    public readonly hasImpressum = computed(() =>
        this.hasKey('impressum.html') && this.settings.impressumShow(),
    );

    public readonly hasPaymentPrivacyAndSecurity = computed(() =>
        this.hasKey('payment_privacy_security.html') && this.settings.subscriptionPaymentShow(),
    );

    public readonly hasCookiePolicy = computed(() => this.hasKey('cookies_policy.html'));

    public hasGdpr(): boolean {
        return environment.operator.didomi && (environment.operator.didomiApiKey?.length > 0);
    }

    public openGdpr(): void {
        Didomi.preferences.show();
    }
}
